import VRemarkFileList from './index.vue';

export default {
  install: (Vue) => Vue.component('VRemarkFileList', VRemarkFileList),
};
